import classNames from "classnames";
import findIndex from "lodash/findIndex";
import { Button } from "PFComponents/button";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";

import css from "./wizard_steps.module.scss";

export type WizardStepsItem = {
  id: string;
  title: string;
  qaId?: string;
};

export type WizardStepsProps = {
  steps: WizardStepsItem[];
  activeStepId: string;
  onStepClick?: (id: string) => void;
  isStepDisabled?: (index: number) => boolean;
  className?: string;
};

export const WizardSteps = ({
  steps,
  activeStepId,
  onStepClick,
  isStepDisabled,
  className
}: WizardStepsProps) => {
  const activeStepIndex = findIndex(steps, { id: activeStepId });

  return (
    <Inline spread gap="spacingLg" className={classNames(css.steps, className)}>
      {steps.map((step, index) => {
        const isActive = index === activeStepIndex;

        return (
          <Button
            kind="ghost"
            key={step.id}
            className={classNames(css.step, { [css.selected]: index <= activeStepIndex })}
            onClick={() => onStepClick?.(step.id)}
            qaId={step.qaId}
            disabled={isStepDisabled?.(index)}
            aria-current={isActive ? "step" : undefined}
          >
            <Typography variant={isActive ? "bodyButtons" : "bodyRegular"}>{step.title}</Typography>
          </Button>
        );
      })}
    </Inline>
  );
};
